import axios from "axios";
import {
    ADMIN_PROFILE_INFORMATION_REQUEST,
    ADMIN_PROFILE_INFORMATION_REQUEST_SUCCESS,
    ADMIN_PROFILE_INFORMATION_REQUEST_FAIL,
} from "./adminConstants";

const userTokenLocal = localStorage.getItem("token")

export const getProfileInformation = () => async (dispatch) => {

    try {

        dispatch({
            type: ADMIN_PROFILE_INFORMATION_REQUEST,
        })

        if (typeof userTokenLocal !== 'undefined') {

            if (userTokenLocal !== "" && userTokenLocal !== null) {

                const config = {

                    headers: {
                        Authorization: `Bearer ` + userTokenLocal,
                    },

                };

                const { data } = await axios.get('/api/admin/accounts/profile', config).catch(function (error) {

                    dispatch({
                        type: ADMIN_PROFILE_INFORMATION_REQUEST_FAIL,
                        payload: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.'
                    })

                });

                if (data.status === "ok") {

                    // console.log("Log")
                    // console.log(data)

                    dispatch({
                        type: ADMIN_PROFILE_INFORMATION_REQUEST_SUCCESS,
                        payload: data.data
                    })

                }
                else {

                    dispatch({
                        type: ADMIN_PROFILE_INFORMATION_REQUEST_FAIL,
                        payload: 'خطا در دریافت اطلاعات از سرور'
                    })

                }

            }
            else {

                dispatch({
                    type: ADMIN_PROFILE_INFORMATION_REQUEST_FAIL,
                    payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
                })

            }
        }
        else {

            dispatch({
                type: ADMIN_PROFILE_INFORMATION_REQUEST_FAIL,
                payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
            })

        }

    } catch (error) {

        dispatch({

            type: ADMIN_PROFILE_INFORMATION_REQUEST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,

        });

    }
};

/*
    ADMIN_INFORMATION_UPDATE_REQUEST,
    ADMIN_INFORMATION_UPDATE_REQUEST_SUCCESS,
    ADMIN_INFORMATION_UPDATE_REQUEST_FAIL,
    ADMIN_INFORMATION_REQUEST,
    ADMIN_INFORMATION_REQUEST_SUCCESS,
    ADMIN_INFORMATION_REQUEST_FAIL,
    ADMIN_UPDATE_PASSWORD_REQUEST,
    ADMIN_UPDATE_PASSWORD_REQUEST_SUCCESS,
    ADMIN_UPDATE_PASSWORD_REQUEST_FAIL,
    ADMIN_UPDATE_IMAGE_REQUEST,
    ADMIN_UPDATE_IMAGE_REQUEST_SUCCESS,
    ADMIN_UPDATE_IMAGE_REQUEST_FAIL,
*/

// export const adminInformationUpdate = () => async (dispatch) => {
//     try {

//         dispatch({
//             type: ADMIN_INFORMATION_UPDATE_REQUEST,
//         })

//         if (typeof userTokenLocal !== 'undefined') {
//             if (userTokenLocal !== "" && userTokenLocal !== null) {

//                 const config = {
//                     headers: {
//                         Authorization: `Bearer ` + userTokenLocal,
//                     },
//                 };
//                 await axios.get('/api/admin/accounts/profile/updateinfo', config).then(response => {

//                     if (response.data.status === "ok") {

//                         dispatch({
//                             type: ADMIN_INFORMATION_UPDATE_REQUEST_SUCCESS,
//                             payload: response.data.data
//                         })

//                     }
//                     else {

//                         dispatch({
//                             type: ADMIN_INFORMATION_UPDATE_REQUEST_FAIL,
//                             payload: 'خطا در دریافت اطلاعات از سرور'
//                         })

//                     }

//                 }).catch(function (error) {

//                     dispatch({
//                         type: ADMIN_INFORMATION_UPDATE_REQUEST_FAIL,
//                         payload: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.'
//                     })

//                 });

//             }
//             else {

//                 dispatch({
//                     type: ADMIN_INFORMATION_UPDATE_REQUEST_FAIL,
//                     payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
//                 })

//             }
//         }
//         else {

//             dispatch({
//                 type: ADMIN_INFORMATION_UPDATE_REQUEST_FAIL,
//                 payload: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.'
//             })

//         }

//     } catch (error) {

//         dispatch({
//             type: ADMIN_INFORMATION_UPDATE_REQUEST_FAIL,
//             payload:
//                 error.response && error.response.data.message
//                     ? error.response.data.message
//                     : error.message,
//         });

//     }
// };

// export const adminProfileUpdate = (formData) => async (dispatch) => {
//     try {

//         dispatch({
//             type: USER_UPDATE_PROFILE_REQUEST,
//         })

//         if (typeof userTokenLocal !== 'undefined') {

//             if (userTokenLocal !== "" && userTokenLocal !== null) {

//                 await axios.post("/api/admin/accounts/profile/updatetexts", formData, {

//                     headers: {
//                         Authorization: `Bearer ` + userTokenLocal,
//                         'content-type': 'multipart/form-data'
//                     }

//                 }).then(function (response) {

//                     //console.log("Profile Update Result:")
//                     //console.log(response.data)

//                     if (response.data.status === "ok") {

//                         dispatch({
//                             type: USER_UPDATE_PROFILE_REQUEST_SUCCESS,
//                             payload: { status: true, message: 'اطلاعات کاربری شما با موفقیت بروز شد.' }
//                         })

//                     }
//                     else {

//                         dispatch({
//                             type: USER_UPDATE_PROFILE_REQUEST_FAIL,
//                             payload: { status: false, message: 'خطا در ارسال اطلاعات' }
//                         })

//                     }

//                 }).catch(function (error) {

//                     dispatch({
//                         type: USER_UPDATE_PROFILE_REQUEST_FAIL,
//                         payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
//                     })

//                 });

//             }
//             else {

//                 dispatch({
//                     type: USER_PROFILE_INFORMATION_REQUEST_FAIL,
//                     payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
//                 })

//             }
//         }
//         else {

//             dispatch({
//                 type: USER_PROFILE_INFORMATION_REQUEST_FAIL,
//                 payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
//             })

//         }

//     } catch (error) {
//         dispatch({
//             type: USER_UPDATE_PROFILE_REQUEST_FAIL,
//             payload:
//             {
//                 status: false, message: error.response && error.response.data.message
//                     ? error.response.data.message
//                     : error.message
//             }
//         });
//     }
// };

// export const adminPasswordUpdate = (formData) => async (dispatch) => {
//     try {

//         dispatch({
//             type: ADMIN_UPDATE_PASSWORD_REQUEST,
//         })

//         if (typeof userTokenLocal !== 'undefined') {

//             if (userTokenLocal !== "" && userTokenLocal !== null) {

//                 await axios.post("/api/admin/accounts/profile/updatepassword", formData, {

//                     headers: {
//                         Authorization: `Bearer ` + userTokenLocal,
//                         'content-type': 'multipart/form-data'
//                     }

//                 }).then(function (response) {

//                     console.log("Password Update Result:")
//                     console.log(response)
//                     if (response.data.status === "error" && response.data.message === "CurrentPasswordInvalid") {

//                         dispatch({
//                             type: ADMIN_UPDATE_PASSWORD_REQUEST_SUCCESS,
//                             payload: { status: false, message: 'رمز عبور فعلی صحیح نیست.' }
//                         })

//                     }
//                     else if (response.data.status === "ok") {

//                         dispatch({
//                             type: ADMIN_UPDATE_PASSWORD_REQUEST_SUCCESS,
//                             payload: { status: true, message: 'رمز عبور شما با موفقیت تغییر کرد.' }
//                         })

//                     }
//                     else {

//                         dispatch({
//                             type: ADMIN_UPDATE_PASSWORD_REQUEST_FAIL,
//                             payload: { status: false, message: 'خطا در ارسال اطلاعات' }
//                         })

//                     }

//                 }).catch(function (error) {

//                     dispatch({
//                         type: ADMIN_UPDATE_PASSWORD_REQUEST_FAIL,
//                         payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
//                     })

//                 });

//             }
//             else {

//                 dispatch({
//                     type: ADMIN_UPDATE_PASSWORD_REQUEST_FAIL,
//                     payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
//                 })

//             }
//         }
//         else {

//             dispatch({
//                 type: ADMIN_UPDATE_PASSWORD_REQUEST_FAIL,
//                 payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
//             })

//         }

//     } catch (error) {
//         dispatch({
//             type: ADMIN_UPDATE_PASSWORD_REQUEST_FAIL,
//             payload: {
//                 status: false, message:
//                     error.response && error.response.data.message
//                         ? error.response.data.message
//                         : error.message
//             }
//         });
//     }
// };

// export const adminImageUpdate = (formData) => async (dispatch) => {
//     try {

//         dispatch({
//             type: ADMIN_UPDATE_IMAGE_REQUEST,
//         })

//         if (typeof userTokenLocal !== 'undefined') {

//             if (userTokenLocal !== "" && userTokenLocal !== null) {

//                 await axios.post("/api/admin/accounts/profile/updateimg", formData, {

//                     headers: {
//                         Authorization: `Bearer ` + userTokenLocal,
//                         'content-type': 'multipart/form-data'
//                     }

//                 }).then(function (response) {

//                     //console.log("Image Update Result:")
//                     //console.log(response)

//                     if (response.data.status === "ok") {

//                         dispatch({
//                             type: ADMIN_UPDATE_IMAGE_REQUEST_SUCCESS,
//                             payload: { status: true, message: 'تصویر کاربری با موفقیت بروز شد.' }
//                         })

//                     }
//                     else {

//                         dispatch({
//                             type: ADMIN_UPDATE_IMAGE_REQUEST_FAIL,
//                             payload: { status: false, message: 'خطا در ارسال اطلاعات' }
//                         })

//                     }

//                 }).catch(function (error) {

//                     dispatch({
//                         type: ADMIN_UPDATE_IMAGE_REQUEST_FAIL,
//                         payload: { status: false, message: 'خطا در انجام عملیات، در فرصت دیگری مجددا امتحان نمایید.' }
//                     })

//                 });

//             }
//             else {

//                 dispatch({
//                     type: ADMIN_UPDATE_IMAGE_REQUEST_FAIL,
//                     payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
//                 })

//             }
//         }
//         else {

//             dispatch({
//                 type: ADMIN_UPDATE_IMAGE_REQUEST_FAIL,
//                 payload: { status: false, message: 'اعتبار ورود شما منقضی شده. لطفا دوباره وارد شوید.' }
//             })

//         }

//     } catch (error) {
//         dispatch({
//             type: ADMIN_UPDATE_IMAGE_REQUEST_FAIL,
//             payload: { status: false, message: error.response && error.response.data.message ? error.response.data.message : error.message, }
//         });
//     }
// };
